const DEFAULT_HEADERS = {
  Accept: '*/*',
  'Content-type': 'application/json',
}
const DEFAULT_CREDENTIALS = { credentials: 'include' }

export async function fetchJsonData(
  url,
  headers = DEFAULT_HEADERS,
  credentials = DEFAULT_CREDENTIALS
) {
  const options = {
    method: 'get',
    headers,
  }

  if (credentials) {
    Object.assign(options, credentials)
  }

  const response = await fetch(url, options)
  dispatchServiceCalled(url)
  if (response.ok) {
    return JSON.parse(await response.text())
  } else {
    return response
  }
}

export async function fetchJsonRawReponse(url, headers = DEFAULT_HEADERS) {
  const response = await fetch(url, {
    method: 'get',
    headers,
    credentials: 'include',
  })
  dispatchServiceCalled(url)
  return response
}

export async function postJsonData(url, data, headers = DEFAULT_HEADERS) {
  const response = await fetch(url, {
    method: 'post',
    headers,
    body: JSON.stringify(data),
    credentials: 'include',
  })
  dispatchServiceCalled(url)
  const responseText = await response.text()

  if (responseText) {
    return JSON.parse(responseText)
  } else {
    return response
  }
}

export async function postJsonRawResponse(
  url,
  data,
  headers = DEFAULT_HEADERS
) {
  const response = await fetch(url, {
    method: 'post',
    headers,
    body: JSON.stringify(data),
    credentials: 'include',
  })
  dispatchServiceCalled(url)
  return response
}

export async function putJsonData(url, data, headers = DEFAULT_HEADERS) {
  const response = await fetch(url, {
    method: 'put',
    headers,
    body: JSON.stringify(data),
    credentials: 'include',
  })
  dispatchServiceCalled(url)
  const responseText = await response.text()
  if (responseText) {
    return JSON.parse(responseText)
  } else {
    return response
  }
}

export async function postJsonDataBlankResponse(url, data) {
  const response = await fetch(url, {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json',
    },
    body: JSON.stringify(data),
    credentials: 'include',
  })
  dispatchServiceCalled(url)
  return response
}

function dispatchServiceCalled(url) {
  const event = new CustomEvent('triggerServiceCalled', {
    detail: {
      url: url,
    },
  })
  document.body && document.body.dispatchEvent(event)
}
